/**
 * User: herbert
 * Date: 19.04.16
 * Time: 11:07
 */

// the whole app is presentation only so we disable jsx-ally
/* eslint jsx-a11y/onclick-has-role: 0 */
/* eslint jsx-a11y/img-has-alt: 0 */

import React from 'react';

import steleActions from '../../actions/stele-actions.js';

import T from '../../../../nls/translate.js';
import * as config from '../../../../config.js';


//function onNoCharging() {
//	steleActions.setChargingCount(0);
//}
function on1Charging() {
	steleActions.setChargingCount(1);
}
function on2Charging() {
	steleActions.setChargingCount(2);
}
function on3Charging() {
	steleActions.setChargingCount(3);
}

function onBasic() {
	steleActions.setChargingType(config.C_TYPE_BASIC);
}
function onAdv() {
	steleActions.setChargingType(config.C_TYPE_ADV);
}
function onProf() {
	steleActions.setChargingType(config.C_TYPE_PROF);
}
function on3k7() {
	steleActions.setChargingPower(config.C_POWER_3k7);
}
function on11k() {
	steleActions.setChargingPower(config.C_POWER_11k);
}
function on22k() {
	steleActions.setChargingPower(config.C_POWER_22k);
}


export default function (elems, charging, showInfoCallback) {
	const positions = (charging.count === 1 || charging.count === 2) ? 3 : 1; // TODO create and use definitions in config.js
	const nextPosition = function () {
		console.log('nextPositioning: ' + ((charging.positioning + 1)%positions));
		steleActions.setChargingPositioning((charging.positioning + 1)%positions);
	};
	elems.push(
		<div key="coc1" className="slx-stele-options__charging-column">
			<div className="slx-stele-options__charging-field" style={{backgroundImage: 'url(img/ladestation/'+config.CHARGING_POSITION_IMGS[charging.count][charging.positioning]+')'}} onMouseDown={nextPosition} >
			{T.current.STELE.CHARGING_DOOR}
			</div>
			<div className={'slx-stele-options__charging-field-third slx-stele-options__size'+(charging.count === 1?' slx-stele-options__selected':'')} onClick={on1Charging}>
				1
			</div>
			<div className={'slx-stele-options__charging-field-third slx-stele-options__size'+(charging.count === 2?' slx-stele-options__selected':'')} onClick={on2Charging}>
				2
			</div>
			<div className={'slx-stele-options__charging-field-third slx-stele-options__size'+(charging.count === 3?' slx-stele-options__selected':'')} onClick={on3Charging}>
				3
			</div>
		</div>);

	elems.push(
		<div key="coc3" className="slx-stele-options__charging-columnWhite">
			<div>
				<span className={'slx-stele-options__charging-span slx-stele-options__size'+(charging.type === config.C_TYPE_PROF ? ' slx-stele-options__selected':'')}
					  onClick={onProf}>
					{T.current.STELE.CHARGING_PROF}
				</span>
				<div className="slx-stele-options__charging-info" onClick={showInfoCallback} />
			</div>
			<div>
				<span className={'slx-stele-options__charging-span slx-stele-options__size'+(charging.type === config.C_TYPE_ADV ? ' slx-stele-options__selected':'')}
					  onClick={onAdv}>
					{T.current.STELE.CHARGING_ADV}
				</span>
				<div className="slx-stele-options__charging-info" onClick={showInfoCallback} />
			</div>
			<div>
				<span className={'slx-stele-options__charging-span slx-stele-options__size'+(charging.type === config.C_TYPE_BASIC ? ' slx-stele-options__selected':'')}
					  onClick={onBasic}>
					{T.current.STELE.CHARGING_BASIC}
				</span>
				<div className="slx-stele-options__charging-info" onClick={showInfoCallback} />
			</div>
			<div className="slx-stele-options__charging-power">
				<span onClick={on3k7} className={'slx-stele-options__size'+(charging.power === config.C_POWER_3k7 ? ' slx-stele-options__selected':'')} >
					{'3'+T.current.MATH.FRACTION+'7kW'}
				</span>
				<span onClick={on11k} className={'slx-stele-options__size'+(charging.power === config.C_POWER_11k ? ' slx-stele-options__selected':'')} >
					11kW
				</span>
				<span onClick={on22k} className={'slx-stele-options__size'+(charging.power === config.C_POWER_22k ? ' slx-stele-options__selected':'')} >
					22kW
				</span>
			</div>
		</div>);
}
